import { render, staticRenderFns } from "./NewMedicationForm.vue?vue&type=template&id=b15d891a&scoped=true"
import script from "./NewMedicationForm.vue?vue&type=script&lang=js"
export * from "./NewMedicationForm.vue?vue&type=script&lang=js"
import style0 from "./NewMedicationForm.vue?vue&type=style&index=0&id=b15d891a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15d891a",
  null
  
)

export default component.exports